/** @format */

const FlightDataActionTypes = {
  GET_FLIGHT_IDS_START: 'GET_FLIGHT_IDS_START',
  GET_FLIGHT_IDS_SUCCESS: 'GET_FLIGHT_IDS_SUCCESS',
  GET_FLIGHT_IDS_FAILURE: 'GET_FLIGHT_IDS_FAILURE',

  GET_FLIGHT_TIMES_START: 'GET_FLIGHT_TIMES_START',
  GET_FLIGHT_TIMES_SUCCESS: 'GET_FLIGHT_TIMES_SUCCESS',
  GET_FLIGHT_TIMES_FAILURE: 'GET_FLIGHT_TIMES_FAILURE',

  // TODO: Connect to backend for data
  GET_FLIGHT_DELAY_START: 'GET_FLIGHT_DELAY_START',
  GET_FLIGHT_DELAY_SUCCESS: 'GET_FLIGHT_DELAY_SUCCESS',
  GET_FLIGHT_DELAY_FAILURE: 'GET_FLIGHT_DELAY_FAILURE',

  SET_DOF: 'SET_DOF',
  SET_CUSTOMER_COUNT: 'SET_CUSTOMER_COUNT',
  SET_FLIGHT_ID_LOADING: 'SET_FLIGHT_ID_LOADING',
  SET_CUSTOMER_DATA_LOADING: 'SET_CUSTOMER_DATA_LOADING',

  SET_SELECTED_FLIGHT_IDS: 'SET_SELECTED_FLIGHT_IDS',

  SET_FILTERED_FLIGHT_IDS: 'SET_FILTERED_FLIGHT_IDS',
  GET_FILTERED_FLIGHT_IDS: 'GET_FILTERED_FLIGHT_IDS',

  SET_FILTER_TIME_START: 'SET_FILTER_TIME_START',
  SET_FILTER_TIME_END: 'SET_FILTER_TIME_END',

  GET_FILTER_TIME_START: 'GET_FILTER_TIME_START',
  GET_FILTER_TIME_END: 'GET_FILTER_TIME_END',

  GET_CUSTOMER_DATA_START: 'GET_CUSTOMER_DATA_START',
  GET_CUSTOMER_DATA_SUCCESS: 'GET_CUSTOMER_DATA_SUCCESS',
  GET_CUSTOMER_DATA_FAILURE: 'GET_CUSTOMER_DATA_FAILURE',

  FLIGHT_DATA_RESET: 'FLIGHT_DATA_RESET',
};

export default FlightDataActionTypes;
